module.exports = __webpack_public_path__ + "static/media/logo_img.003fbac2.svg";